import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SettingsContext = createContext(null);

// Hardcoded branding - these values are fixed and cannot be changed
const FIXED_BRANDING = {
  platform_name: "WOC",
  platform_subtitle: "WiLAN Operations Center",
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const { token } = useAuth();
  const [settings, setSettings] = useState({
    ...FIXED_BRANDING,
    company_name: "WiLAN",
    global_notification_email: "administracion@wilan.es",
  });
  const [loading, setLoading] = useState(true);

  const fetchSettings = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/settings`);
      setSettings({
        // Hardcoded branding - always use fixed values
        ...FIXED_BRANDING,
        // Other settings from API
        company_name: response.data.company_name || "WiLAN",
        global_notification_email: response.data.global_notification_email || "administracion@wilan.es",
      });
    } catch (error) {
      console.error("Error fetching settings:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Defer the /api/settings call until there is an active session token —
  // fetching it pre-auth produced a 403 that cluttered the React console on the
  // login screen. Branding falls back to FIXED_BRANDING until then.
  useEffect(() => {
    if (token) {
      fetchSettings();
    } else {
      setLoading(false);
    }
  }, [token, fetchSettings]);

  const refreshSettings = () => {
    fetchSettings();
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};
